import React, { useCallback, useEffect, useState } from "react";
import { isEmpty, toInteger, toString } from "lodash";
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import Grid from '@mui/material/Grid';
import Checkbox from '@mui/material/Checkbox';
import { useGetInvoiceListMutation, useGetServiceListMutation, useUpdateUserServiceListMutation } from "config/api/waV1_user";
import { useDispatch } from "react-redux";
import { toggleError, toggleNoti } from "config/slice/message";
import { Button } from "@mui/material";
import { KEY_ERROR_FORM_EDIT_FAILED, KEY_FORM_CS_COL_SH_HOLDING, KEY_FORM_CS_TITLE_1, KEY_FORM_CS_TITLE_2, KEY_FORM_EX_CP_COL_ADDR_CN, KEY_FORM_EX_CP_COL_ADDR_EN, KEY_FORM_EX_CP_COL_ISBILINGUISH, KEY_FORM_EX_CP_COL_OTHER, KEY_FORM_EX_CP_COL_POSITION_CN, KEY_FORM_EX_CP_COL_POSITION_EN, KEY_FORM_EX_CP_TITLE_1, KEY_FORM_EX_CP_TITLE_2, KEY_FORM_EX_CS_TITLE_1, KEY_FORM_EX_RB_TITLE_1, KEY_FORM_EX_RB_TM_DESC, KEY_FORM_EX_RB_TM_HOLDER, KEY_FORM_EX_RB_TM_HOLDER_ADDR, KEY_FORM_EX_RB_TM_HOLDER_REG, KEY_FORM_EX_RB_TM_REG, KEY_FORM_EX_RB_TM_TYPE, KEY_FORM_TITLE_1, KEY_FORM_TITLE_2, KEY_FORM_TITLE_3, KEY_FORM_TITLE_4, KEY_FORM_TITLE_5, KEY_FORM_TITLE_6, KEY_FORM_VO_COL_BUS_REG_LICENSE, KEY_FORM_VO_COL_BUS_REG_LICENSE_NO, KEY_FORM_VO_COL_BUS_REG_LICENSE_YES, KEY_FORM_VO_COL_BUS_REG_NUM, KEY_FORM_VO_COL_IDENTITY, KEY_FORM_VO_COL_IDENTITY_COM, KEY_FORM_VO_COL_IDENTITY_IND, KEY_FORM_VO_COL_IDENTITY_ORG, KEY_FORM_VO_COL_MAIN_CONTACT_ADDRESS, KEY_FORM_VO_COL_MAIN_CONTACT_BIRTHDAY, KEY_FORM_VO_COL_MAIN_CONTACT_EMAIL, KEY_FORM_VO_COL_MAIN_CONTACT_IDENTITY, KEY_FORM_VO_COL_MAIN_CONTACT_IDENTITY_AGENT, KEY_FORM_VO_COL_MAIN_CONTACT_IDENTITY_DIRECTOR, KEY_FORM_VO_COL_MAIN_CONTACT_IDENTITY_SECRETARY, KEY_FORM_VO_COL_MAIN_CONTACT_IDENTITY_SH, KEY_FORM_VO_COL_MAIN_CONTACT_IDENTITY_STAFF, KEY_FORM_VO_COL_MAIN_CONTACT_NAME_CN, KEY_FORM_VO_COL_MAIN_CONTACT_NAME_EN, KEY_FORM_VO_COL_MAIN_CONTACT_PHONE, KEY_FORM_VO_COL_MAIN_CONTACT_TITLE, KEY_FORM_VO_COL_MAIN_CONTACT_TITLE_MISS, KEY_FORM_VO_COL_MAIN_CONTACT_TITLE_MR, KEY_FORM_VO_COL_MAIN_CONTACT_TITLE_MRS, KEY_FORM_VO_COL_ORG_NUM, KEY_FORM_VO_COL_REG_CONNTRY, KEY_FORM_VO_COL_REG_DATE, KEY_FORM_VO_TITLE_1, KEY_FORM_VO_TITLE_2, KEY_FORM_VO_TITLE_3, KEY_FORM_VO_TITLE_4, KEY_LABEL_FORM_ADDRESS, KEY_LABEL_FORM_BOARD_COM_FUND_SOURCE, KEY_LABEL_FORM_BOARD_COM_FUND_SOURCE_AFTER, KEY_LABEL_FORM_BOARD_COM_FUND_SOURCE_BEFORE, KEY_LABEL_FORM_BOARD_COM_REG_ADDR, KEY_LABEL_FORM_BOARD_COM_REG_BUS_NUM, KEY_LABEL_FORM_BOARD_COM_REG_C, KEY_LABEL_FORM_BOARD_COM_REG_NUM, KEY_LABEL_FORM_BOARD_HOLADING, KEY_LABEL_FORM_BOARD_INDENTITY, KEY_LABEL_FORM_BOARD_NO_AFTER, KEY_LABEL_FORM_BOARD_NO_BEFORE, KEY_LABEL_FORM_BOARD_NUM, KEY_LABEL_FORM_BOARD_SH_ADDRESS_AFTER, KEY_LABEL_FORM_BOARD_SH_ADDRESS_BEFORE, KEY_LABEL_FORM_BOARD_SH_CN_NAME, KEY_LABEL_FORM_BOARD_SH_EMAIL, KEY_LABEL_FORM_BOARD_SH_EN_NAME, KEY_LABEL_FORM_BOARD_SH_IC_AFTER, KEY_LABEL_FORM_BOARD_SH_IC_BEFORE, KEY_LABEL_FORM_BOARD_SH_ID_AFTER, KEY_LABEL_FORM_BOARD_SH_ID_BEFORE, KEY_LABEL_FORM_BOARD_SH_PHONE, KEY_LABEL_FORM_BUS_NATURE, KEY_LABEL_FORM_BUS_REGION, KEY_LABEL_FORM_CANCEL, KEY_LABEL_FORM_COM_ADDR, KEY_LABEL_FORM_COM_ADDR_REG, KEY_LABEL_FORM_COM_ADDR_USE_DEFAULT, KEY_LABEL_FORM_COM_ADDR_USE_DEFAULT_NO, KEY_LABEL_FORM_COM_ADDR_USE_DEFAULT_YES, KEY_LABEL_FORM_COM_CN_NAME, KEY_LABEL_FORM_COM_EN_NAME, KEY_LABEL_FORM_CONFIRM, KEY_LABEL_FORM_CONTACT_SLOT, KEY_LABEL_FORM_CONTACT_WAY, KEY_LABEL_FORM_EDIT, KEY_LABEL_FORM_EMAIL, KEY_LABEL_FORM_IS_NUM, KEY_LABEL_FORM_NAME, KEY_LABEL_FORM_PHONE, KEY_LABEL_FORM_PRESET_SHARES, KEY_LABEL_FORM_PRESET_SHARES_EN, KEY_LABEL_FORM_PRESET_SHARES_NO, KEY_LABEL_FORM_PRESET_SHARES_YES, KEY_LABEL_FORM_TITLE, KEY_LABEL_FORM_UPLOADED_FILE, KEY_LABEL_FORM_VAL, KEY_LABEL_FORM_VALUE_ADDED, KEY_LABEL_FORM_VAL_EN, KEY_LABEL_FORM_VAL_TOTAL, KEY_LABEL_FORM_VAL_TOTAL_EN, KEY_NOTI_FORM_EDIT_SUCC, MODULE_PREVIEW_ROUTER_FORM } from "config/const/locale";
import { useTranslation } from "react-i18next";
import { format } from "date-fns";
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from "dayjs";


export default function EditableForm_extr(props) {

    let {
        id,
        name,
        title,
        identity,
        en_name,
        zh_name,
        address,
        phone,
        email,
        company_name_en,
        company_name_zh,
        has_bus_reg_license,
        reg_date,
        bus_reg_num,
        reg_country,
        org_num,
        contact_way,
        wechat_no,
        contact_timeslot,
        page,
        company_address,
        is_use_wa_addr,
        company_reg_address,
        is_std_share_value,
        no_shares_issued,
        shares_par_value,
        shares_total_value,
        business_nature,
        geo_location_bus_nature,
        sMemberNum,
        shareholders,
        service,
        source_of_fund,
        files,
        c_title,
        c_en_name,
        c_zh_name,
        c_phone,
        c_email,
        is_bilin,
        company_position_en,
        company_position_zh,
        address_en,
        address_zh,
        remark,
        tm_reg,
        tm_holder,
        tm_holder_addr,
        tm_type,
        tm_desc,
    } = props.user_service
    const { items } = props

    const { t } = useTranslation(MODULE_PREVIEW_ROUTER_FORM)

    const A_SHAREHOLDER = {
        type: '',
        identity: t(KEY_FORM_VO_COL_MAIN_CONTACT_TITLE_MR),
        en_name: '',
        zh_name: '',
        tel: '',
        email: '',
        address: '',
        date_of_birth: new Date(),
    }


    const [userIpt, setUserIpt] = useState({
        name,
        title,
        phone,
        email,
        address,
        identity,
        en_name,
        zh_name,
        phone,
        email,
        company_name_en,
        company_name_zh,
        has_bus_reg_license,
        reg_date,
        bus_reg_num,
        reg_country,
        org_num,
        contact_way,
        wechat_no,
        contact_timeslot,
        page,
        company_name_en,
        company_name_zh,
        company_address,
        is_use_wa_addr,
        company_reg_address,
        is_std_share_value,
        no_shares_issued,
        shares_par_value,
        shares_total_value,
        business_nature,
        geo_location_bus_nature,
        sMemberNum,
        shareholders,
        eService: [service],
        files,
        c_title,
        c_en_name,
        c_zh_name,
        c_phone,
        c_email,
        is_bilin,
        company_position_en,
        company_position_zh,
        address_en,
        address_zh,
        remark,
        tm_reg,
        tm_holder,
        tm_holder_addr,
        tm_type,
        tm_desc,
    })
    const [sh, setSh] = useState([])
    const [isEdit, setIsEdit] = useState(false)
    const [isUpdate, setIsUpdate] = useState(false)
    const [serv, setServ] = React.useState([])
    const [updateUSFn] = useUpdateUserServiceListMutation()
    const [getServiceFn] = useGetServiceListMutation()

    const dispatch = useDispatch()

    const steps = [
        t(KEY_FORM_TITLE_2),
        t(KEY_FORM_EX_CP_TITLE_1),
        t(KEY_FORM_EX_RB_TITLE_1),
    ];

    React.useEffect(() => {
        getServiceFn()
            .then(res => {
                if (res.data?.data) {
                    setServ(res.data?.data?.services?.data)
                }
            })
    }, [])

    const saveVal = (propsName) => (e) => {

        setUserIpt(p => ({ ...p, [propsName]: e.target.value }))
    }

    const updateHandler = () => {

        updateUSFn({
            id,
            payload: {
                ...userIpt,
                is_use_wa_addr: toString(userIpt.is_use_wa_addr),
                is_std_share_value: toString(userIpt.is_std_share_value),
                no_shares_issued: toString(userIpt.no_shares_issued),
                shares_par_value: toString(userIpt.shares_par_value),
                shares_total_value: toString(userIpt.shares_total_value),
                service: [
                    {
                        id: 15,
                        quantity: 1
                    }
                ]
            }
        })
            .then(
                res => {
                    if (res.data?.data && res.data?.status == 200) {
                        dispatch(toggleNoti({
                            indicator: true,
                            msg: t(KEY_NOTI_FORM_EDIT_SUCC)
                        }))
                        setIsUpdate(false)
                        // window.location.reload()
                    } else {
                        dispatch(toggleError({
                            indicator: true,
                            msg: res?.error?.data?.message?.message || t(KEY_ERROR_FORM_EDIT_FAILED)
                        }))
                    }

                }
            )
            .catch(
                reason => {
                    dispatch(toggleError({
                        indicator: true,
                        msg: t(KEY_ERROR_FORM_EDIT_FAILED)
                    }))
                }
            )
    }

    useEffect(() => {
        setUserIpt({
            name,
            title,
            phone,
            email,
            address,
            identity,
            en_name,
            zh_name,
            phone,
            email,
            company_name_en,
            company_name_zh,
            has_bus_reg_license,
            reg_date,
            bus_reg_num,
            reg_country,
            org_num,
            contact_way,
            wechat_no,
            contact_timeslot,
            page,
            company_name_en,
            company_name_zh,
            company_address,
            is_use_wa_addr,
            company_reg_address,
            is_std_share_value,
            no_shares_issued,
            shares_par_value,
            shares_total_value,
            business_nature,
            geo_location_bus_nature,
            sMemberNum,
            shareholders,
            eService: [service],
            files,
        })
        setSh([...shareholders])
    }, [])

    useEffect(() => {
        if (isUpdate) {
            updateHandler()
        }
    }, [isUpdate])

    // const memNoRenderer = useCallback(() => userIpt.shareholders?.map(
    //     (i, index) => {
    //         return (
    //             <Grid container key={index}>
    //                 <Grid item sm={2} sx={{ borderRight: '1px solid black', borderTop: '1px solid black' }}><Typography variant='p'>{t(KEY_LABEL_FORM_BOARD_NO_BEFORE)} {index + 1} {t(KEY_LABEL_FORM_BOARD_NO_AFTER)} </Typography></Grid>
    //                 <Grid item sm={4} sx={{ borderRight: '1px solid black', borderTop: '1px solid black' }}><Typography variant='p'>{isEdit ? <TextField className="wa-yellow w-100 h-100" value={i.type} /> : i.type}</Typography></Grid>
    //                 <Grid item sm={2} sx={{ borderRight: '1px solid black', borderTop: '1px solid black' }}><Typography variant='p'>{t(KEY_LABEL_FORM_BOARD_INDENTITY)} </Typography></Grid>
    //                 <Grid item sm={4} sx={{ borderTop: '1px solid black' }}><Typography variant='p'>{new Array(i?.identity).map(i => i)}</Typography></Grid>
    //                 <Grid item sm={2} sx={{ borderRight: '1px solid black', borderTop: '1px solid black' }}><Typography variant='p'>{t(KEY_LABEL_FORM_BOARD_HOLADING)} </Typography></Grid>
    //                 <Grid item sm={4} sx={{ borderRight: '1px solid black', borderTop: '1px solid black' }}><Typography variant='p'>{isEdit ? <TextField className="wa-yellow w-100 h-100" value={i.shareholding} /> : i.shareholding}</Typography></Grid>
    //                 <Grid item sm={3} sx={{ borderRight: '1px solid black', borderTop: '1px solid black' }}><Typography variant='p'>{t(KEY_LABEL_FORM_BOARD_NO_BEFORE)} {index + 1} {t(KEY_LABEL_FORM_BOARD_SH_EN_NAME)} </Typography></Grid>
    //                 <Grid item sm={3} sx={{ borderTop: '1px solid black' }}><Typography variant='p'>{isEdit ? <TextField className="wa-yellow w-100 h-100" value={i.en_name} /> : i.en_name}</Typography></Grid>
    //                 <Grid item sm={3} sx={{ borderRight: '1px solid black', borderTop: '1px solid black' }}><Typography variant='p'>{t(KEY_LABEL_FORM_BOARD_NO_BEFORE)} {index + 1} {t(KEY_LABEL_FORM_BOARD_SH_CN_NAME)} </Typography></Grid>
    //                 <Grid item sm={3} sx={{ borderRight: '1px solid black', borderTop: '1px solid black' }}><Typography variant='p'>{isEdit ? <TextField className="wa-yellow w-100 h-100" value={i.zh_name} /> : i.zh_name}</Typography></Grid>
    //                 <Grid item sm={2} sx={{ borderRight: '1px solid black', borderTop: '1px solid black' }}><Typography variant='p'>{t(KEY_LABEL_FORM_BOARD_SH_PHONE)} </Typography></Grid>
    //                 <Grid item sm={4} sx={{ borderTop: '1px solid black' }}><Typography variant='p'>{isEdit ? <TextField className="wa-yellow w-100 h-100" value={i.tel} /> : i.tel}</Typography></Grid>
    //                 <Grid item sm={2} sx={{ borderRight: '1px solid black', borderTop: '1px solid black' }}><Typography variant='p'>{t(KEY_LABEL_FORM_BOARD_SH_EMAIL)} </Typography></Grid>
    //                 <Grid item sm={3} sx={{ borderRight: '1px solid black', borderTop: '1px solid black' }}><Typography variant='p'>{isEdit ? <TextField className="wa-yellow w-100 h-100" value={i.email} /> : i.email}</Typography></Grid>
    //                 <Grid item sm={3} sx={{ borderRight: '1px solid black', borderTop: '1px solid black' }}><Typography variant='p'>{t(KEY_LABEL_FORM_BOARD_SH_ADDRESS_BEFORE)} {index + 1} {t(KEY_LABEL_FORM_BOARD_SH_ADDRESS_AFTER)} </Typography></Grid>
    //                 <Grid item sm={4} sx={{ borderTop: '1px solid black' }}><Typography variant='p'>{isEdit ? <TextField className="wa-yellow w-100 h-100" value={i.address} /> : i.address}</Typography></Grid>
    //                 <Grid item sm={3} sx={{ borderRight: '1px solid black', borderTop: '1px solid black' }}><Typography variant='p'>{t(KEY_LABEL_FORM_BOARD_SH_ID_BEFORE)} {index + 1} {t(KEY_LABEL_FORM_BOARD_SH_ID_AFTER)} </Typography></Grid>
    //                 <Grid item sm={3} sx={{ borderRight: '1px solid black', borderTop: '1px solid black' }}><Typography variant='p'>{isEdit ? <TextField className="wa-yellow w-100 h-100" value={i.hkid} /> : i.hkid}</Typography></Grid>
    //                 <Grid item sm={3} sx={{ borderRight: '1px solid black', borderTop: '1px solid black' }}><Typography variant='p'>{t(KEY_LABEL_FORM_BOARD_SH_IC_BEFORE)} {index + 1} {t(KEY_LABEL_FORM_BOARD_SH_IC_AFTER)} </Typography></Grid>
    //                 <Grid item sm={3} sx={{ borderTop: '1px solid black' }}><Typography variant='p'>{isEdit ? <TextField className="wa-yellow w-100 h-100" value={i.issuing_country} /> : i.issuing_country}</Typography></Grid>
    //                 {
    //                     i.type == t(KEY_LABEL_FORM_BOARD_INDENTITY)
    //                         ? (
    //                             <>
    //                                 <Grid item sm={3} sx={{ borderRight: '1px solid black', borderTop: '1px solid black' }}><Typography variant='p'>{t(KEY_LABEL_FORM_BOARD_COM_REG_ADDR)} </Typography></Grid>
    //                                 <Grid item sm={9} sx={{ borderTop: '1px solid black' }}><Typography variant='p'>{isEdit ? <TextField className="wa-yellow w-100 h-100" value={i.co_register_office_addr} /> : i.co_register_office_addr}</Typography></Grid>
    //                                 <Grid item sm={3} sx={{ borderRight: '1px solid black', borderTop: '1px solid black' }}><Typography variant='p'>{t(KEY_LABEL_FORM_BOARD_COM_REG_NUM)} </Typography></Grid>
    //                                 <Grid item sm={3} sx={{ borderRight: '1px solid black', borderTop: '1px solid black' }}><Typography variant='p'>{isEdit ? <TextField className="wa-yellow w-100 h-100" value={i.co_incorp_no} /> : i.co_incorp_no}</Typography></Grid>
    //                                 <Grid item sm={3} sx={{ borderRight: '1px solid black', borderTop: '1px solid black' }}><Typography variant='p'>{t(KEY_LABEL_FORM_BOARD_COM_REG_BUS_NUM)} </Typography></Grid>
    //                                 <Grid item sm={3} sx={{ borderTop: '1px solid black' }}><Typography variant='p'>{isEdit ? <TextField className="wa-yellow w-100 h-100" value={i.business_registration} /> : i.business_registration}</Typography></Grid>
    //                                 <Grid item sm={3} sx={{ borderRight: '1px solid black', borderTop: '1px solid black' }}><Typography variant='p'>{t(KEY_LABEL_FORM_BOARD_COM_REG_C)} </Typography></Grid>
    //                                 <Grid item sm={9} sx={{ borderTop: '1px solid black' }}><Typography variant='p'>{isEdit ? <TextField className="wa-yellow w-100 h-100" value={i.formation_country} /> : i.formation_country}</Typography></Grid>
    //                             </>
    //                         )
    //                         : (isEmpty(source_of_fund) && isEmpty(shareholders[0]?.source_of_fund))
    //                             ? false
    //                             : (
    //                                 <>
    //                                     <Grid item sm={3} sx={{ borderRight: '1px solid black', borderTop: '1px solid black' }}><Typography variant='p'>{isEmpty(source_of_fund) ? `${t(KEY_LABEL_FORM_BOARD_COM_FUND_SOURCE_BEFORE)}${index + 1}${t(KEY_LABEL_FORM_BOARD_COM_FUND_SOURCE_AFTER)}` : t(KEY_LABEL_FORM_BOARD_COM_FUND_SOURCE)} </Typography></Grid>
    //                                     <Grid item sm={9} sx={{ borderTop: '1px solid black' }} ><Typography variant='p'>{isEmpty(source_of_fund) ? i.source_of_fund : source_of_fund}</Typography></Grid>
    //                                 </>
    //                             )
    //                 }
    //             </Grid>
    //         )
    //     }
    // ), [userIpt.shareholders, isEdit, isUpdate])

    const handleArrayValue = (flag, value, array) => {
        if (flag) {
            if (new Array(...array).indexOf(value) !== -1) return array
            else return [...array, value]
        } else {
            return new Array(...array).filter(i => i !== value)
        }
    }

    const memNoRenderer = () => userIpt.shareholders?.map(
        (i, index) => {
            return (
                <Grid container key={index}>
                    <Grid item sm={2} sx={{ borderRight: '1px solid black', borderTop: '1px solid black' }}><Typography variant='p'>{t(KEY_FORM_VO_COL_MAIN_CONTACT_IDENTITY)} </Typography></Grid>
                    <Grid item sm={4} sx={{ borderRight: '1px solid black', borderTop: '1px solid black' }}><Typography variant='p'>
                        {/* {
                            isEdit
                                ? (
                                    <RadioGroup
                                        row
                                        name="type"
                                        className='wa-yellow'
                                    >
                                        <FormControlLabel control={<Checkbox value={t(KEY_FORM_VO_COL_MAIN_CONTACT_IDENTITY_DIRECTOR)} checked={i.type.indexOf(t(KEY_FORM_VO_COL_MAIN_CONTACT_IDENTITY_DIRECTOR)) == -1 ? false : true} onChange={(e) => { i.type = handleArrayValue(e.target.checked, e.target.value, i.type); setUserIpt(p => ({ ...p, shareholders: [...shareholders] })) }} />} label={t(KEY_FORM_VO_COL_MAIN_CONTACT_IDENTITY_DIRECTOR)} />
                                        <FormControlLabel control={<Checkbox value={t(KEY_FORM_VO_COL_MAIN_CONTACT_IDENTITY_SH)} checked={i.type.indexOf(t(KEY_FORM_VO_COL_MAIN_CONTACT_IDENTITY_SH)) == -1 ? false : true} onChange={(e) => { i.type = handleArrayValue(e.target.checked, e.target.value, i.type); setUserIpt(p => ({ ...p, shareholders: [...shareholders] })) }} />} label={t(KEY_FORM_VO_COL_MAIN_CONTACT_IDENTITY_SH)} />
                                        <FormControlLabel control={<Checkbox value={t(KEY_FORM_VO_COL_MAIN_CONTACT_IDENTITY_SECRETARY)} checked={i.type.indexOf(t(KEY_FORM_VO_COL_MAIN_CONTACT_IDENTITY_SECRETARY)) == -1 ? false : true} onChange={(e) => { i.type = handleArrayValue(e.target.checked, e.target.value, i.type); setUserIpt(p => ({ ...p, shareholders: [...shareholders] })) }} />} label={t(KEY_FORM_VO_COL_MAIN_CONTACT_IDENTITY_SECRETARY)} />
                                        <FormControlLabel control={<Checkbox value={t(KEY_FORM_VO_COL_MAIN_CONTACT_IDENTITY_STAFF)} checked={i.type.indexOf(t(KEY_FORM_VO_COL_MAIN_CONTACT_IDENTITY_STAFF)) == -1 ? false : true} onChange={(e) => { i.type = handleArrayValue(e.target.checked, e.target.value, i.type); setUserIpt(p => ({ ...p, shareholders: [...shareholders] })) }} />} label={t(KEY_FORM_VO_COL_MAIN_CONTACT_IDENTITY_STAFF)} />
                                        <FormControlLabel control={<Checkbox value={t(KEY_FORM_VO_COL_MAIN_CONTACT_IDENTITY_AGENT)} checked={i.type.indexOf(t(KEY_FORM_VO_COL_MAIN_CONTACT_IDENTITY_AGENT)) == -1 ? false : true} onChange={(e) => { i.type = handleArrayValue(e.target.checked, e.target.value, i.type); setUserIpt(p => ({ ...p, shareholders: [...shareholders] })) }} />} label={t(KEY_FORM_VO_COL_MAIN_CONTACT_IDENTITY_AGENT)} />
                                    </RadioGroup>
                                )
                                : new Array(i?.type).map(i => i)
                        } */}
                        {new Array(i?.type).map(i => i)}
                    </Typography></Grid>
                    <Grid item sm={2} sx={{ borderRight: '1px solid black', borderTop: '1px solid black' }}><Typography variant='p'>{t(KEY_FORM_VO_COL_MAIN_CONTACT_TITLE)} </Typography></Grid>
                    <Grid item sm={4} sx={{ borderTop: '1px solid black' }}><Typography variant='p'>
                        {/* {
                            isEdit ?
                                <RadioGroup
                                    row
                                    aria-labelledby="demo-radio-buttons-group-label"
                                    className='wa-yellow h-100'
                                    value={i?.identity}
                                    name="identity"
                                    onChange={(e) => {
                                        i.identity = e.target.value
                                        setUserIpt(p => ({ ...p, shareholders: [...shareholders] }))
                                    }}
                                >
                                    <FormControlLabel value={t(KEY_FORM_VO_COL_MAIN_CONTACT_TITLE_MR)} control={<Radio />} label={t(KEY_FORM_VO_COL_MAIN_CONTACT_TITLE_MR)} />
                                    <FormControlLabel value={t(KEY_FORM_VO_COL_MAIN_CONTACT_TITLE_MISS)} control={<Radio />} label={t(KEY_FORM_VO_COL_MAIN_CONTACT_TITLE_MISS)} />
                                    <FormControlLabel value={t(KEY_FORM_VO_COL_MAIN_CONTACT_TITLE_MRS)} control={<Radio />} label={t(KEY_FORM_VO_COL_MAIN_CONTACT_TITLE_MRS)} />
                                </RadioGroup>
                                : i?.identity
                        } */}
                        {i?.identity}
                    </Typography></Grid>
                    <Grid item sm={2} sx={{ borderRight: '1px solid black', borderTop: '1px solid black' }}><Typography variant='p'>{t(KEY_FORM_VO_COL_MAIN_CONTACT_NAME_EN)} </Typography></Grid>
                    <Grid item sm={4} sx={{ borderRight: '1px solid black', borderTop: '1px solid black' }}><Typography variant='p'>
                        {/* {isEdit ? <TextField className="wa-yellow w-100 h-100" value={i.en_name} /> : i.en_name} */}
                        {i.en_name}
                    </Typography></Grid>
                    <Grid item sm={2} sx={{ borderRight: '1px solid black', borderTop: '1px solid black' }}><Typography variant='p'>{t(KEY_FORM_VO_COL_MAIN_CONTACT_NAME_CN)} </Typography></Grid>
                    <Grid item sm={4} sx={{ borderTop: '1px solid black' }}><Typography variant='p'>
                        {/* {
                        isEdit ? <TextField className="wa-yellow w-100 h-100" value={i.zh_name} /> : i.zh_name
                    } */}
                        {i.zh_name}
                    </Typography></Grid>
                    <Grid item sm={2} sx={{ borderRight: '1px solid black', borderTop: '1px solid black' }}><Typography variant='p'>{t(KEY_FORM_VO_COL_MAIN_CONTACT_PHONE)} </Typography></Grid>
                    <Grid item sm={4} sx={{ borderRight: '1px solid black', borderTop: '1px solid black' }}><Typography variant='p'>
                        {/* {
                        isEdit ? <TextField className="wa-yellow w-100 h-100" value={i.tel} /> : i.tel
                    } */}
                        {i.tel}
                    </Typography></Grid>
                    <Grid item sm={2} sx={{ borderRight: '1px solid black', borderTop: '1px solid black' }}><Typography variant='p'>{t(KEY_FORM_VO_COL_MAIN_CONTACT_EMAIL)} </Typography></Grid>
                    <Grid item sm={4} sx={{ borderTop: '1px solid black' }}><Typography variant='p'>
                        {/* {
                        isEdit ? <TextField className="wa-yellow w-100 h-100" value={i.email} /> : i.email} */}
                        {i.email}
                    </Typography></Grid>
                    <Grid item sm={2} sx={{ borderRight: '1px solid black', borderTop: '1px solid black' }}><Typography variant='p'>{t(KEY_FORM_VO_COL_MAIN_CONTACT_ADDRESS)} </Typography></Grid>
                    <Grid item sm={10} sx={{ borderTop: '1px solid black' }}><Typography variant='p'>
                        {/* {
                        isEdit ? <TextField className="wa-yellow w-100 h-100" value={i.address} /> : i.address} */}
                        {i.address}
                    </Typography></Grid>

                    {/* {
                        i.type == t(KEY_LABEL_FORM_BOARD_INDENTITY)
                            ? (
                                <>
                                    <Grid item sm={3} sx={{ borderRight: '1px solid black', borderTop: '1px solid black' }}><Typography variant='p'>{t(KEY_LABEL_FORM_BOARD_COM_REG_ADDR)} </Typography></Grid>
                                    <Grid item sm={9} sx={{ borderTop: '1px solid black' }}><Typography variant='p'>{i.co_register_office_addr}</Typography></Grid>
                                    <Grid item sm={3} sx={{ borderRight: '1px solid black', borderTop: '1px solid black' }}><Typography variant='p'>{t(KEY_LABEL_FORM_BOARD_COM_REG_NUM)} </Typography></Grid>
                                    <Grid item sm={3} sx={{ borderRight: '1px solid black', borderTop: '1px solid black' }}><Typography variant='p'>{i.co_incorp_no}</Typography></Grid>
                                    <Grid item sm={3} sx={{ borderRight: '1px solid black', borderTop: '1px solid black' }}><Typography variant='p'>{t(KEY_LABEL_FORM_BOARD_COM_REG_BUS_NUM)} </Typography></Grid>
                                    <Grid item sm={3} sx={{ borderTop: '1px solid black' }}><Typography variant='p'>{i.business_registration}</Typography></Grid>
                                    <Grid item sm={3} sx={{ borderRight: '1px solid black', borderTop: '1px solid black' }}><Typography variant='p'>{t(KEY_LABEL_FORM_BOARD_COM_REG_C)} </Typography></Grid>
                                    <Grid item sm={9} sx={{ borderTop: '1px solid black' }}><Typography variant='p'>{i.formation_country}</Typography></Grid>
                                </>
                            )
                            : (isEmpty(source_of_fund) && isEmpty(shareholders[0]?.source_of_fund))
                                ? false
                                : (
                                    <>
                                        <Grid item sm={3} sx={{ borderRight: '1px solid black', borderTop: '1px solid black' }}><Typography variant='p'>{isEmpty(source_of_fund) ? `${t(KEY_LABEL_FORM_BOARD_COM_FUND_SOURCE_BEFORE)}${index + 1}${t(KEY_LABEL_FORM_BOARD_COM_FUND_SOURCE_AFTER)}` : t(KEY_LABEL_FORM_BOARD_COM_FUND_SOURCE)} </Typography></Grid>
                                        <Grid item sm={9} sx={{ borderTop: '1px solid black' }} ><Typography variant='p'>{isEmpty(source_of_fund) ? i.source_of_fund : source_of_fund}</Typography></Grid>
                                    </>
                                )
                    } */}
                </Grid>
            )
        }
    )

    const typeRender = () => {
        switch (title) {
            case t(KEY_FORM_VO_COL_IDENTITY_COM):
                return (
                    <>
                        <Grid item sm={2} sx={{ borderRight: '1px solid black', borderBottom: '1px solid black' }}><Typography variant='p'> {t(KEY_FORM_VO_COL_IDENTITY)} </Typography></Grid>
                        <Grid item sm={10} sx={{ borderBottom: '1px solid black' }}><Typography variant='p'> {
                            isEdit
                                ? (
                                    <RadioGroup
                                        row
                                        name="title"
                                        className='wa-yellow'
                                    >
                                        <FormControlLabel control={<Checkbox value={t(KEY_FORM_VO_COL_IDENTITY_COM)} checked={userIpt.title == t(KEY_FORM_VO_COL_IDENTITY_COM) ? true : false} onChange={saveVal('title')} />} label={t(KEY_FORM_VO_COL_IDENTITY_COM)} />
                                        <FormControlLabel control={<Checkbox value={t(KEY_FORM_VO_COL_IDENTITY_IND)} checked={userIpt.title == t(KEY_FORM_VO_COL_IDENTITY_IND) ? true : false} onChange={saveVal('title')} />} label={t(KEY_FORM_VO_COL_IDENTITY_IND)} />
                                        <FormControlLabel control={<Checkbox value={t(KEY_FORM_VO_COL_IDENTITY_ORG)} checked={userIpt.title == t(KEY_FORM_VO_COL_IDENTITY_ORG) ? true : false} onChange={saveVal('title')} />} label={t(KEY_FORM_VO_COL_IDENTITY_ORG)} />
                                    </RadioGroup>
                                )
                                : userIpt.title
                        }</Typography></Grid>
                        <Grid item sm={2} sx={{ borderRight: '1px solid black', borderBottom: '1px solid black' }}><Typography variant='p'> {t(KEY_LABEL_FORM_COM_EN_NAME)} </Typography></Grid>
                        <Grid item sm={4} sx={{ borderRight: '1px solid black', }}><Typography variant='p'> {isEdit ? <TextField className="wa-yellow w-100 h-100" value={userIpt.company_name_en} onChange={saveVal('company_name_en')} /> : userIpt.company_name_en}</Typography></Grid>
                        <Grid item sm={2} sx={{ borderRight: '1px solid black' }}><Typography variant='p'> {t(KEY_LABEL_FORM_COM_CN_NAME)} </Typography></Grid>
                        <Grid item sm={4} ><Typography variant='p'> {isEdit ? <TextField className="wa-yellow w-100 h-100" value={userIpt.company_name_zh} onChange={saveVal('company_name_zh')} /> : userIpt.company_name_zh}</Typography></Grid>
                        <Grid item sm={2} sx={{ borderRight: '1px solid black' }}><Typography variant='p'> {t(KEY_FORM_VO_COL_BUS_REG_LICENSE)} </Typography></Grid>
                        <Grid item sm={1} sx={{ borderRight: '1px solid black', borderTop: '1px solid black' }}><Typography variant='p'> {
                            isEdit
                                ? (
                                    <RadioGroup
                                        row
                                        name="has_bus_reg_license"
                                        className='wa-yellow'
                                    >
                                        <FormControlLabel control={<Checkbox value='0' checked={userIpt.has_bus_reg_license == '0' ? true : false} onChange={saveVal('has_bus_reg_license')} />} label={t(KEY_FORM_VO_COL_BUS_REG_LICENSE_NO)} />
                                        <FormControlLabel control={<Checkbox value='1' checked={userIpt.has_bus_reg_license == '0' ? false : true} onChange={saveVal('has_bus_reg_license')} />} label={t(KEY_FORM_VO_COL_BUS_REG_LICENSE_YES)} />
                                    </RadioGroup>
                                )
                                :
                                userIpt.has_bus_reg_license == '0' ? t(KEY_FORM_VO_COL_BUS_REG_LICENSE_NO) : t(KEY_FORM_VO_COL_BUS_REG_LICENSE_YES)
                        }</Typography></Grid>
                        <Grid item sm={2} sx={{ borderRight: '1px solid black', borderTop: '1px solid black' }}><Typography variant='p'> {t(KEY_FORM_VO_COL_REG_DATE)} </Typography></Grid>
                        <Grid item sm={7} sx={{ borderTop: '1px solid black' }}><Typography variant='p'> {
                            isEdit ? (
                                <FormControl className='wa-yellow h-100 w-100'>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DatePicker
                                            value={dayjs(reg_date)}
                                            onChange={(val) => { setUserIpt(p => ({ ...p, reg_date: format(val?.toISOString(), 'yyyy-MM-dd') })) }}
                                        />
                                    </LocalizationProvider>
                                </FormControl>
                            ) : reg_date && format(new Date(reg_date)?.toISOString(), 'yyyy-MM-dd')
                        }</Typography></Grid>

                        {
                            has_bus_reg_license == '0' ? false
                                : (
                                    <>
                                        <Grid item sm={2} sx={{ borderRight: '1px solid black', borderTop: '1px solid black', borderBottom: '1px solid black' }}><Typography variant='p'> {t(KEY_FORM_VO_COL_BUS_REG_NUM)} </Typography></Grid>
                                        <Grid item sm={10} sx={{ borderTop: '1px solid black', borderBottom: '1px solid black' }}><Typography variant='p'> {
                                            isEdit ? <TextField className="wa-yellow w-100 h-100" value={userIpt.bus_reg_num} onChange={saveVal('bus_reg_num')} /> : userIpt.bus_reg_num
                                        }</Typography></Grid>
                                    </>
                                )
                        }
                    </>
                )
            case t(KEY_FORM_VO_COL_IDENTITY_IND):
                return (
                    <>
                        <Grid item sm={2} sx={{ borderRight: '1px solid black', borderBottom: '1px solid black' }}><Typography variant='p'> {t(KEY_FORM_VO_COL_MAIN_CONTACT_TITLE)} </Typography></Grid>
                        <Grid item sm={10} sx={{ borderBottom: '1px solid black' }}><Typography variant='p'> {identity}</Typography></Grid>
                        <Grid item sm={2} sx={{ borderRight: '1px solid black', borderBottom: '1px solid black' }}><Typography variant='p'> {t(KEY_FORM_VO_COL_MAIN_CONTACT_NAME_EN)} </Typography></Grid>
                        <Grid item sm={4} sx={{ borderRight: '1px solid black', }}><Typography variant='p'> {en_name}</Typography></Grid>
                        <Grid item sm={2} sx={{ borderRight: '1px solid black' }}><Typography variant='p'> {t(KEY_FORM_VO_COL_MAIN_CONTACT_NAME_CN)} </Typography></Grid>
                        <Grid item sm={4} ><Typography variant='p'> {zh_name}</Typography></Grid>
                        <Grid item sm={2} sx={{ borderRight: '1px solid black' }}><Typography variant='p'> {t(KEY_FORM_VO_COL_MAIN_CONTACT_ADDRESS)} </Typography></Grid>
                        <Grid item sm={10} sx={{ borderTop: '1px solid black' }}><Typography variant='p'> {address}</Typography></Grid>
                    </>
                )
            case t(KEY_FORM_VO_COL_IDENTITY_ORG):
                return (
                    <>
                        <Grid item sm={2} sx={{ borderRight: '1px solid black', borderBottom: '1px solid black' }}><Typography variant='p'> {t(KEY_LABEL_FORM_COM_EN_NAME)} </Typography></Grid>
                        <Grid item sm={10} sx={{ borderBottom: '1px solid black' }}><Typography variant='p'> {company_name_en}</Typography></Grid>
                        <Grid item sm={2} sx={{ borderRight: '1px solid black', borderBottom: '1px solid black' }}><Typography variant='p'> {t(KEY_LABEL_FORM_COM_CN_NAME)} </Typography></Grid>
                        <Grid item sm={4} sx={{ borderRight: '1px solid black', }}><Typography variant='p'> {company_name_zh}</Typography></Grid>
                        <Grid item sm={2} sx={{ borderRight: '1px solid black' }}><Typography variant='p'> {t(KEY_FORM_VO_COL_REG_CONNTRY)} </Typography></Grid>
                        <Grid item sm={4} ><Typography variant='p'> {reg_country}</Typography></Grid>
                        <Grid item sm={2} sx={{ borderRight: '1px solid black' }}><Typography variant='p'> {t(KEY_FORM_VO_COL_ORG_NUM)} </Typography></Grid>
                        <Grid item sm={10} sx={{ borderTop: '1px solid black' }}><Typography variant='p'> {org_num}</Typography></Grid>
                    </>
                )

            default:
                return (
                    <>
                        <Grid item sm={2} sx={{ borderRight: '1px solid black', borderBottom: '1px solid black' }}><Typography variant='p'> {t(KEY_FORM_VO_COL_MAIN_CONTACT_TITLE)} </Typography></Grid>
                        <Grid item sm={10} sx={{ borderBottom: '1px solid black' }}><Typography variant='p'> {c_title}</Typography></Grid>
                        <Grid item sm={2} sx={{ borderRight: '1px solid black', borderBottom: '1px solid black' }}><Typography variant='p'> {t(KEY_FORM_VO_COL_MAIN_CONTACT_NAME_EN)} </Typography></Grid>
                        <Grid item sm={4} sx={{ borderRight: '1px solid black', }}><Typography variant='p'> {c_en_name}</Typography></Grid>
                        <Grid item sm={2} sx={{ borderRight: '1px solid black' }}><Typography variant='p'> {t(KEY_FORM_VO_COL_MAIN_CONTACT_NAME_CN)} </Typography></Grid>
                        <Grid item sm={4} ><Typography variant='p'> {c_zh_name}</Typography></Grid>
                        <Grid item sm={2} sx={{ borderRight: '1px solid black' }}><Typography variant='p'> {t(KEY_FORM_VO_COL_MAIN_CONTACT_PHONE)} </Typography></Grid>
                        <Grid item sm={4} sx={{ borderTop: '1px solid black', borderRight: '1px solid black' }}><Typography variant='p'> {c_phone}</Typography></Grid>
                        <Grid item sm={2} sx={{ borderRight: '1px solid black', borderTop: '1px solid black' }}><Typography variant='p'> {t(KEY_FORM_VO_COL_MAIN_CONTACT_EMAIL)} </Typography></Grid>
                        <Grid item sm={4} sx={{ borderTop: '1px solid black' }}><Typography variant='p'> {c_email}</Typography></Grid>
                    </>
                )
        }
    }

    return (
        <>
            <Box sx={{ pt: 4, pb: 4 }}>
                <Grid container spacing={2} sx={{ mb: 2 }}>
                    <Grid item sm={2}>&nbsp;</Grid>
                    <Grid item sm={2}><Button variant='contained' onClick={isEdit ? () => { setIsEdit(false); setIsUpdate(true) } : () => setIsEdit(true)}>{isEdit ? t(KEY_LABEL_FORM_CONFIRM) : t(KEY_LABEL_FORM_EDIT)}</Button></Grid>
                    <Grid item sm={2}><Button variant='contained' onClick={() => { setIsEdit(false); setIsUpdate(false) }}>{t(KEY_LABEL_FORM_CANCEL)}</Button></Grid>
                    {/* <Grid item sm={2}><Button variant='contained' onClick={() => { setIsEdit(false); setIsUpdate(true) }}>完成</Button></Grid> */}
                </Grid>
                <Box sx={{ width: '80%', m: '0 auto', border: '1px solid black', fontSize: 16, lineHeight: 2 }}>
                    <Grid container>
                        <Grid item sm={12} sx={{ borderBottom: '1px solid black' }}><Typography variant='h5' sx={{ fontWeight: 700 }}> {steps[0]}</Typography></Grid>
                        <Grid item sm={12} sx={{ borderTop: '1px solid black' }}><Typography variant='p'>
                            {
                                isEdit
                                    ? (
                                        <Box sx={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center' }} >
                                            <FormLabel id="demo-radio-buttons-group-label" sx={{ mr: 2 }}>服務： </FormLabel>
                                            <RadioGroup
                                                row
                                                aria-labelledby="demo-radio-buttons-group-label"
                                                className='wa-yellow'
                                            >
                                                {
                                                    serv.filter(i => !i.name.includes('value_added_service')).map(
                                                        i => <FormControlLabel value={i.service_name} control={<Checkbox disabled checked={!isEmpty(items.filter(it => it.service_name == i.name))} />} label={i.locale_name} />
                                                    )
                                                }
                                                {/* {
                                                    items.map(
                                                        i => <FormControlLabel value={i.service_name} control={<Checkbox checked={true} />} label={serv.filter(it => it.name == i.service_name)[0].locale_name} />
                                                    )
                                                } */}
                                            </RadioGroup>
                                        </Box>
                                    )
                                    : serv.filter(i => -1 !== items?.map(i => i.service_name).filter(i => i.indexOf('value_added_service') == -1)?.indexOf(i.name)).map(i => i.locale_name).join(', ')
                            }
                        </Typography>
                        </Grid>

                        <Grid item sm={12} sx={{ borderBottom: '1px solid black', borderTop: '1px solid black' }}><Typography variant='h5' sx={{ fontWeight: 700 }}>&nbsp;</Typography></Grid>
                        <Grid item sm={12} sx={{ borderBottom: '1px solid black' }}><Typography variant='h5' sx={{ fontWeight: 700 }}> {steps[1]}</Typography></Grid>
                        {typeRender()}

                        <Grid item sm={12} sx={{ borderBottom: '1px solid black', borderTop: '1px solid black' }}><Typography variant='h5' sx={{ fontWeight: 700 }}>&nbsp;</Typography></Grid>
                        <Grid item sm={12} sx={{ borderBottom: '1px solid black' }}><Typography variant='h5' sx={{ fontWeight: 700 }}> {steps[2]}</Typography></Grid>

                        <Grid item sm={3} sx={{ borderRight: '1px solid black', borderBottom: '1px solid black' }}><Typography variant='p'> {t(KEY_FORM_EX_RB_TM_REG)} </Typography></Grid>
                        <Grid item sm={9} sx={{ borderBottom: '1px solid black', borderBottom: '1px solid black' }}><Typography variant='p'> {tm_reg}</Typography></Grid>
                        <Grid item sm={3} sx={{ borderRight: '1px solid black', borderBottom: '1px solid black' }}><Typography variant='p'> {t(KEY_FORM_EX_RB_TM_HOLDER)} </Typography></Grid>
                        <Grid item sm={9} sx={{ borderBottom: '1px solid black' }}><Typography variant='p'> {tm_holder}</Typography></Grid>
                        <Grid item sm={3} sx={{ borderRight: '1px solid black', borderBottom: '1px solid black' }}><Typography variant='p'> {t(KEY_FORM_EX_RB_TM_HOLDER_ADDR)} </Typography></Grid>
                        <Grid item sm={9} sx={{ borderBottom: '1px solid black' }}><Typography variant='p'> {tm_holder_addr}</Typography></Grid>
                        <Grid item sm={3} sx={{ borderRight: '1px solid black', borderBottom: '1px solid black' }}><Typography variant='p'> {t(KEY_FORM_EX_RB_TM_TYPE)} </Typography></Grid>
                        <Grid item sm={9} sx={{ borderBottom: '1px solid black' }}><Typography variant='p'> {tm_type}</Typography></Grid>
                        <Grid item sm={3} sx={{ borderRight: '1px solid black' }}><Typography variant='p'> {t(KEY_FORM_EX_RB_TM_DESC)} </Typography></Grid>
                        <Grid item sm={9} sx={{}}><Typography variant='p'> {tm_desc}</Typography></Grid>


                        {/* <Grid item sm={12} sx={{ borderTop: '1px solid black' }}><Typography variant='h5' sx={{ fontWeight: 700 }}> {steps[3]}</Typography></Grid>
                        <Grid item sm={3} sx={{ borderRight: '1px solid black', borderTop: '1px solid black' }}><Typography variant='p'>{t(KEY_LABEL_FORM_VALUE_ADDED)} </Typography></Grid>
                        <Grid item sm={9} sx={{ borderTop: '1px solid black' }} className={isEdit ? "wa-yellow" : ''} >
                            <Typography variant='p' >
                                {
                                    isEdit
                                        ?
                                        serv.filter(i => i.name.includes('value_added_service')).map(
                                            i => <FormControlLabel value={i.service_name} control={<Checkbox disabled checked={!isEmpty(items.filter(it => it.service_name == i.name))} />} label={i.locale_name} />
                                        )
                                        : serv.filter(i => -1 !== items?.map(i => i.service_name).filter(i => i.indexOf('value_added_service') !== -1)?.indexOf(i.name)).map(i => i.locale_name).join(', ')
                                }
                            </Typography>
                        </Grid> */}


                    </Grid>
                </Box>
            </Box >

        </>
    );
}
